﻿/**
 * Centralized Site and Organization Configuration
 * Connect Source Architecture
 */

import { SiteSettings } from '../types/siteSettings';

export const siteConfig: SiteSettings = {
  siteName: 'Connect Source',
  tagline: 'Career Transformation, HR & Business Support Platform',
  baseUrl: 'https://connectsource.co.in',
  defaultCurrency: 'INR',
  contactEmail: 'info@connectsource.co.in',
  supportPhone: '+91 70395 57887',
  whatsappNumber: '+917039557887',
  socialLinks: {
    linkedin: 'https://www.linkedin.com/company/connect-source',
    twitter: 'https://twitter.com/connectsourcein',
    youtube: 'https://youtube.com/@connectsourcein'
  },
  
legal: {
  companyName: 'Connect Source',
  address: 'Mumbai, Maharashtra, India',
  gstin: '27AUPPM8385H1ZT',
  supportEmail: 'info@connectsource.co.in'
},
  maintenanceMode: false
};

